import { Injectable } from '@angular/core';
import { IAbstractPresenter, ILanguageObject } from '@core/interfaces';
import { Store as StoreModel } from '@core/models';
import { StoreDeliveryCodeEnum } from '../../../enums';
import { IStoresListCallback } from '../../../interfaces';
import { IPickupStrategyComponent, IPickupStrategyPresenter } from './interfaces';

@Injectable()
export class PickupStrategyPresenter
	extends IAbstractPresenter<IPickupStrategyComponent>
	implements IPickupStrategyPresenter
{
	stores: StoreModel[] = [];
	translations: ILanguageObject = {};
	callback!: IStoresListCallback;

	dispatchActions(): void {}

	suscribeObservers(): void {}

	onSelectStore(store: StoreModel, code: StoreDeliveryCodeEnum): void {
		this.view?.callback?.onSelectStore(store, code);
	}
}
